
export const SUPPORT_EMAIL = "hpvendorsupport@zomato.com";
